export default __webpack_public_path__ + "static/media/camera-removebg-preview.5300bfe0.png";